module.exports = __webpack_public_path__ + "img/silver1.ae3b88bf.gif";